module.exports = __webpack_public_path__ + "static/media/phd_gatenga2.743be8ed.jpg";